<div class="app-content">
  <div class="top-toolbars-wrapper top-toolbars-wrapper-static">
    <!-- toolbars-wrapper -->
    <mat-toolbar id="primary_toolbar" class="header-toolbar center65">
      <img *ngIf="account && account.logo" src="{{account.logo}}" class="account-logo"
           alt="Account logo" (click)="application.handleGoHome()">
      <div class="fs-navigation">
        <div class="switcher">
          <!--<a [routerLink]="['/files']" routerLinkActive="router-zero-active" *ngIf="true">Files</a>-->
          <!--<a [routerLink]="['/snapshots']" routerLinkActive="router-zero-active" *ngIf="true">Snapshots</a>-->
        </div>
        <div class="flex" style="align-items: center;">
          <div class="fs-navigation-btn flex" style="align-items: center;">
            <div class="username-wrapper" *ngIf="!application.user || !application.user.id" i18n>Login</div>
            <div class="username-wrapper" *ngIf="application.user && application.user.id">
              <span i18n>Hi</span>, {{application.user.shipping_name.split(" ")[0]}}
            </div>

            <button mat-icon-button *ngIf="!application.user || !application.user.id"
                    class="account-circle"
                    (click)="showLoginPopup()">
              <mat-icon class="icon-color bigger-icon">account_circle</mat-icon>
              <mat-icon class="icon-color">arrow_drop_down</mat-icon>
            </button>
            <button mat-icon-button *ngIf="application.user && application.user.id"
                    class="account-circle"
                    [matMenuTriggerFor]="toolbarUserMenu"
                    (menuOpened)="application.setUserMenuOpened(true)"
                    (menuClosed)="application.setUserMenuOpened(false)">
              <mat-icon class="icon-color bigger-icon">account_circle</mat-icon>
              <mat-icon class="icon-color" *ngIf="!application.userMenuOpened">arrow_drop_down</mat-icon>
              <mat-icon class="icon-color" *ngIf="application.userMenuOpened">arrow_drop_up</mat-icon>
            </button>

            <mat-menu #toolbarUserMenu="matMenu" xPosition="before" class="toolbar-user-menu">
              <app-user-menu [userMenuOpened]="application.userMenuOpened"></app-user-menu>
            </mat-menu>
          </div>
        </div>
      </div>
    </mat-toolbar>
  </div>
  <app-article-view></app-article-view>
</div>
